<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <a name="add"></a>
        <h4 class="title is-4">
          <i class="fas fa-language"></i>&nbsp;Add your language
        </h4>
      </div>
    </div>
    <div class="card-content">
      <div class="content">
        ...
      </div>
    </div>
  </div>
</template>
